/**
 * Definições de pastas de email padrão
 */

import type { EmailFolder, EmailFolderType } from '../types/email.types';

/** Pastas padrão do email */
export const DEFAULT_FOLDERS: EmailFolder[] = [
  { id: 'inbox', label: 'Caixa de Entrada', icon: 'FiInbox' },
  { id: 'starred', label: 'Favoritos', icon: 'FiStar' },
  { id: 'sent', label: 'Enviados', icon: 'FiSend' },
  { id: 'drafts', label: 'Rascunhos', icon: 'FiFile' },
  { id: 'spam', label: 'Spam', icon: 'FiAlertOctagon' },
  { id: 'trash', label: 'Lixeira', icon: 'FiTrash2' },
  { id: 'archive', label: 'Arquivo', icon: 'FiArchive' },
];

/** Mapeamento de folder → status/filtro backend */
export const FOLDER_TO_FILTER: Record<EmailFolderType, Record<string, unknown>> = {
  inbox: { status: ['waiting', 'active'], excludeConversationTags: ['spam', 'trash', 'archived'] },
  starred: { conversationTags: ['starred'] },
  sent: { status: ['active', 'closed'], sortBy: 'createdAt' },
  drafts: { status: ['waiting'], conversationTags: ['draft'] },
  spam: { conversationTags: ['spam'] },
  trash: { status: ['closed'], conversationTags: ['trash'] },
  archive: { status: ['closed'], conversationTags: ['archived'] },
};
